import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'User',
  },
  {
    displayName: 'User Access',
    iconName: 'point',
    route: '/access/users',
    // Require use:access. 18/09/2026 CN
    expectedScopes: ['use:access'],
  },
  {
    navCap: 'Merchant Admin',
  },
  {
    displayName: 'Merchant Setup',
    iconName: 'point',
    route: '/mad/msetable',
    // Require use:mse. 18/09/2026 CN
    expectedScopes: ['use:mse'],
  },
  {
    displayName: 'Service Point Setup',
    iconName: 'point',
    route: '/mad/spstable',
    // Require use:sps. 18/09/2026 CN
    expectedScopes: ['use:sps'],
  },
  {
    displayName: 'Service Point Info',
    iconName: 'point',
    route: '/mad/spitable',
    // Require use:spi. 18/09/2026 CN
    expectedScopes: ['use:spi'],
  },
  {
    navCap: 'Product',
  },
  {
    displayName: 'Product List',
    iconName: 'point',
    route: '/pli/plitable',
    // See C001 - 2026-09-16 - HE: use:product (catalogue); was use:product-list
    expectedScopes: ['use:product'],
  },
  {
    navCap: 'Portal',
  },
  {
    displayName: 'Portal Register',
    iconName: 'point',
    route: '/portal/portalregistertable',
    // Require use:portal. 18/09/2026 CN
    expectedScopes: ['use:portal'],
  },
  // Dashboard image for Amber Issuing home. 21/10/2026 DW
  {
    displayName: 'Dashboard Image',
    iconName: 'point',
    route: '/noticeboard/dashboard-notice',
    expectedScopes: ['use:template'],
  },
  {
    navCap: 'SMS/E-mail Functions',
  },

  {
    displayName: 'SMS/E-mail Functions',
    iconName: 'home',
    route: 'sms',
    // Require use:sms-email. 18/09/2026 CN
    expectedScopes: ['use:sms-email'],
    children: [
      {
        displayName: 'Token',
        iconName: 'box',
        route: 'sms/tokentable',
        // Require use:token. 18/09/2026 CN
        expectedScopes: ['use:token'],
      },
      {
        displayName: 'Template',
        iconName: 'box',
        route: 'sms/templatetable',
        // Require use:template. 18/09/2026 CN
        expectedScopes: ['use:template'],
      },

      {
        displayName: 'Event Link',
        iconName: 'box',
        route: 'sms/eventlinktable',
        // Require use:event. 18/09/2026 CN
        expectedScopes: ['use:event'],
      },
    ],
  },
  {
    navCap: 'Financial Setup',
  },
  {
    displayName: 'Financial Setup',
    iconName: 'home',
    route: 'fin',
    // Require use:finsetup. 18/09/2026 CN
    expectedScopes: ['use:finsetup'],
    children: [
      {
        displayName: 'BFee Group',
        iconName: 'point',
        route: 'fin/bfeetable',
        // Require read:bfg. 18/09/2026 CN
        expectedScopes: ['read:bfg'],
      },
      {
        displayName: 'FIN Wizard',
        iconName: 'point',
        route: 'fin/finwizard',
        // Require read:fin. 18/09/2026 CN
        expectedScopes: ['read:fin'],
      },
      {
        displayName: 'Financial Instruction',
        iconName: 'point',
        route: 'fin/fintable',
        // Require read:fin. 18/09/2026 CN
        expectedScopes: ['read:fin'],
      },
      {
        displayName: 'Fraud Rule List',
        iconName: 'point',
        route: 'fin/frltable',
        // Require read:frl. 18/09/2026 CN
        expectedScopes: ['read:frl'],
      },
      {
        displayName: 'Source',
        iconName: 'point',
        route: 'fin/soutable',
        // Require read:sou. 18/09/2026 CN
        expectedScopes: ['read:sou'],
      },
      {
        displayName: 'Documentation List',
        iconName: 'point',
        route: 'fin/dlitable',
        // Require read:dli. 18/09/2026 CN
        expectedScopes: ['read:dli'],
      },
      {
        displayName: 'Chart Of Account',
        iconName: 'point',
        route: 'fin/coatable',
        // Require read:coa. 18/09/2026 CN
        expectedScopes: ['read:coa'],
      },
      {
        displayName: 'Interest Rate',
        iconName: 'point',
        route: 'fin/iratable',
        // Require read:ira. 18/09/2026 CN
        expectedScopes: ['read:ira'],
      },
      {
        displayName: 'Setup Account Service',
        iconName: 'point',
        route: 'fin/setupaccountservicetable',
        // Require read:sas. 18/09/2026 CN
        expectedScopes: ['read:sas'],
      },
      {
        displayName: 'Source Group',
        iconName: 'point',
        route: 'fin/sgrtable',
        // Require read:sgr. 18/09/2026 CN
        expectedScopes: ['read:sgr'],
      },
      {
        displayName: 'Source Group Temp',
        iconName: 'point',
        route: 'fin/sgttable',
        // Require read:sgr. 18/09/2026 CN
        expectedScopes: ['read:sgr'],
      },
    ],
  },
  {
    navCap: 'Auth0',
  },
  {
    displayName: 'Application',
    iconName: 'point',
    route: '/auth0/application',
    // See C001 - 2026-09-16 - HE: require use:develop so Setup Administrator (use:auth0 only) is hidden
    expectedScopes: ['use:auth0', 'use:develop'],
  },
  {
    displayName: 'Resource',
    iconName: 'point',
    route: '/auth0/resource',
    // Require use:auth0 + use:develop. 18/09/2026 CN
    expectedScopes: ['use:auth0', 'use:develop'],
  },
  {
    navCap: 'Auth0 Permissions',
  },
  {
    displayName: 'Groups',
    iconName: 'point',
    route: '/auth0/groups',
    // Require use:auth0 + use:develop. 18/09/2026 CN
    expectedScopes: ['use:auth0', 'use:develop'],
  },
  {
    navCap: 'Maintenance',
  },
  {
    displayName: 'Maintenance',
    iconName: 'settings',
    route: 'maintenance',
    // Require use:maintenance. 18/09/2026 CN
    expectedScopes: ['use:maintenance'],
    children: [
      {
        displayName: 'FIN Core',
        iconName: 'point',
        route: 'maintenance',
        // Require use:fincore. 18/09/2026 CN
        expectedScopes: ['use:fincore'],
      },
    ],
  },
];
